import EngineModule                 from '../EngineModule';
import { NS as LanguageSelectorNS } from '../components/LanguageSelector/LanguageSelector';


export default () => new EngineModule.LogicalEngineModule({
	type :             'logical',
	id :               'language-selector',
	dependencies :     [],
	allowedCustomers : null,
	insertionPath :    'K.visualization.topRightMenu',
	generateComponentConfiguration() : LanguageSelectorNS.Configuration {
		return {
			translations : this.translations,
		};
	},
	async initialize() {
	}
});
